import React from "react";
import { Link } from "react-router";

export default function Footer() {
    return (
        <div className="footer-container">
            <ul>
                <li>
                    <Link to="https://discord.gg/mPBM9tVcBJ"><img src="/ds.png" alt="ds" className="logo123"/></Link>
                    <Link to="https://t.me/raytolfas"><img src="/tg.png" alt="tg" className="logo123"/></Link>
                    <Link to="https://www.youtube.com/@raytolfas"><img src="/yt.png" alt="yt" className="logo123"/></Link>
                </li>
            </ul>
        </div>
    )
}